import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import RewardService from "services/rewardService";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import { Button, CircularProgress, Grid, Typography } from "@mui/material";
import MDTypography from "components/MDTypography";
import { useMediaQuery } from "react-responsive";
import Card from "@mui/material/Card";
import { Divider } from "@mui/material";
import HistoryCards from "../HistoryCards";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import gift from "assets/images/trophy.png";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useDispatch, useSelector } from "react-redux";
import MDAvatar from "components/MDAvatar";
import singhCoinCurrency from "assets/images/singhCoinCurrency.png";
import { getRewardsLike } from "services/rewardService";
import ClaimedCards from "../claimedCards";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { getRewardsComment } from "services/rewardService";
import { getRewardsPosts } from "services/rewardService";
import { getRewardsNft } from "services/rewardService";
import { getRewardsEngagement } from "services/rewardService";
import { getRewardsEvent } from "services/rewardService";
import SpinLoader from "components/SpinLoader";
import InfiniteScroll from "react-infinite-scroll-component";

const RewardDetails = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    allRewardsEarned,
    totalRewardsEarned,
    balanceReward,
    claimHistory,
    claimHistoryPageNumber,
    isRewardLoading,
    isAllRewardLoading,
    isClaimHistoryLoading,
  } = useSelector((state) => state.userRewards);

  const [pageNumber, setPageNumber] = useState(1);

  const [rewardsDetailsData, setRewardDetailsData] = useState([]);

  const [name, setName] = useState("");

  const [loading, setLoading] = useState(true);

  const [isFetchMore, setIsFetchMore] = useState(false);

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });

  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  const rewardType = {
    like: getRewardsLike,
    comment: getRewardsComment,
    posts: getRewardsPosts,
    nft: getRewardsNft,
    engagement: getRewardsEngagement,
    event: getRewardsEvent,
  };

  const timeType = {
    like: "likeTime",
    comment: "commentTime",
    posts: "postTime",
    nft: "mintTime",
    engagement: "creditTime",
    event: "eventTime",
  };

  useEffect(() => {
    fetchRewardDetails();
  }, []);

  const fetchRewardDetails = async () => {
    setLoading(true);

    if (searchParams.get("type") === "like") {
      setName("Like on Post");
    } else if (searchParams.get("type") === "comment") {
      setName("Commenting on Post");
    } else if (searchParams.get("type") === "posts") {
      setName("Creating Post");
    } else if (searchParams.get("type") === "nft") {
      setName("Nft Created");
    } else if (searchParams.get("type") === "engagement") {
      setName("Engagement");
    } else if (searchParams.get("type") === "event") {
      setName("Creating Event");
    }

    const rewardDetailsRes = await rewardType[searchParams.get("type")](
      localStorage.userNameSingh,
      1
    );

    // console.log("rewardDetailsRes", rewardDetailsRes);

    if (rewardDetailsRes.status === 200) {
      if (rewardDetailsRes.data.length > 1) {
        setIsFetchMore(true);
      }

      setRewardDetailsData(rewardDetailsRes.data);
      setLoading(false);
    }
    setLoading(false);
  };

  const fetchMoreRewardData = async () => {
    const rewardDetailsRes = await rewardType[searchParams.get("type")](
      localStorage.userNameSingh,
      pageNumber + 1
    );

    if (rewardDetailsRes.status === 200) {
      if (rewardDetailsRes.data.length < 1) {
        setIsFetchMore(false);
        return;
      }

      setIsFetchMore(true);
      setRewardDetailsData(rewardsDetailsData.concat(rewardDetailsRes.data));
      setPageNumber((prev) => prev + 1);
    }
  };

  const capitalizeFirstLetter = (value) => {
    return value && value[0].toUpperCase() + value.slice(1);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Card
        sx={{
          backgroundColor: "#1a1a1a",
          padding: 1,
        }}
      >
        <MDBox>
          <MDBox sx={{ display: "flex", justifyContent: "center" }}>
            <MDTypography>
              {capitalizeFirstLetter(searchParams.get("type"))} Rewards Earned
            </MDTypography>
          </MDBox>
        </MDBox>

        <MDBox>
          <InfiniteScroll
            dataLength={rewardsDetailsData.length}
            next={() => fetchMoreRewardData()}
            hasMore={isFetchMore}
            loader={
              <MDBox sx={{ textAlign: "center" }}>
                <SpinLoader />
              </MDBox>
            }
          >
            {loading ? (
              <MDBox
                sx={{
                  height: "100px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <MDTypography color="singh">
                  <CircularProgress color="inherit" />
                </MDTypography>
              </MDBox>
            ) : rewardsDetailsData.length > 0 ? (
              <MDBox display="flex" flexDirection="column">
                {rewardsDetailsData.map((item, idx) => (
                  <ClaimedCards
                    key={idx}
                    color="success"
                    icon={<EmojiEventsIcon fontSize="inherit" />}
                    name={name}
                    description={item.postId}
                    description2={item[timeType[searchParams.get("type")]]}
                    value={item.SinghReward}
                  />
                ))}
              </MDBox>
            ) : (
              <MDBox sx={{ textAlign: "center" }}>
                <MDTypography color="text" sx={{ marginTop: "4rem" }}>
                  No Data found
                </MDTypography>
              </MDBox>
            )}
          </InfiniteScroll>
        </MDBox>
      </Card>
    </DashboardLayout>
  );
};

export default RewardDetails;
